var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWww(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_www__Icn/40px/www",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_www__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_www__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.999,24 L9.99960742,25.9992656 L29.9996074,25.9992656 L29.999,24 L32,24 L32,26.0526316 C32,27.1208959 31.1493854,28 30.0833333,28 L9.91666667,28 C8.85061465,28 8,27.1208959 8,26.0526316 L8,24 L9.999,24 Z M6.795,16 L7.973,19.7278107 L8.011,19.7278107 L9.094,16 L10.614,16 L11.64,19.7278107 L11.678,19.7278107 L12.837,16 L14.889,16 L12.609,22 L10.899,22 L9.835,18.4378698 L9.797,18.4378698 L8.733,22 L7.023,22 L4.743,16 L6.795,16 Z M16.979,16 L18.157,19.7278107 L18.195,19.7278107 L19.278,16 L20.798,16 L21.824,19.7278107 L21.862,19.7278107 L23.021,16 L25.073,16 L22.793,22 L21.083,22 L20.019,18.4378698 L19.981,18.4378698 L18.917,22 L17.207,22 L14.927,16 L16.979,16 Z M27.163,16 L28.341,19.7278107 L28.379,19.7278107 L29.462,16 L30.982,16 L32.008,19.7278107 L32.046,19.7278107 L33.205,16 L35.257,16 L32.977,22 L31.267,22 L30.203,18.4378698 L30.165,18.4378698 L29.101,22 L27.391,22 L25.111,16 L27.163,16 Z M30.0833333,10 C31.1493854,10 32,10.8791041 32,11.9473684 L32,14 L29.999,14 L29.9996074,11.9992656 L9.99960742,11.9992656 L9.999,14 L8,14 L8,11.9473684 C8,10.9299739 8.77153256,10.0841531 9.76590767,10.0059058 L9.91666667,10 L30.0833333,10 Z",
    id: ".._.._src_svg_Icn_40px_www__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWww);
export default __webpack_public_path__ + "static/media/www.595b738fc6e3a09ee63cfb04f1d4505d.svg";
export { ForwardRef as ReactComponent };